import React, { useEffect, useRef, useState } from 'react'
import Layout from '../common/Layout'
import ApiHelper from '../../helperFunction/ApiHelper'
import API_ENDPOINTS from '../../helperFunction/Constant'
import { useNavigate, useParams } from 'react-router-dom'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { IconField } from 'primereact/iconfield'
import { InputIcon } from 'primereact/inputicon'
import { InputText } from 'primereact/inputtext'
import { Toast } from 'primereact/toast'
import { ConfirmDialog } from 'primereact/confirmdialog'

const AffiliateOrders = () => {

    const toast = useRef(null)
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [affiliateData, setAffiliateData] = useState([])

    const navigate = useNavigate()

    const { id } = useParams()

    useEffect(() => {
        getAffiliates()
    }, [])
    
    const getAffiliates = async () => {
        await ApiHelper.get(`${API_ENDPOINTS.AFFILIATE_ORDERS}/${id}`).then((res) => {
        // console.log('res: ', res);
        if (res.status === 200) {
            setAffiliateData(res.data.data)
            }
        }).catch((error) => {
            console.log("Error: ", error);
        })
    }

    const serialNoTemplate = (rowData, options) => { return options.rowIndex + 1; };

    const userDetailBodyTemplate = (rowData) => {
        return (
            <>
                <span>{rowData.userName}</span>
                <br/>
                <span>{rowData.userMobileNumber}</span>
            </>
        );
    };

    const imageBodyTemplate = (rowData) => {
        const courseCount = rowData?.courses?.length || 0;
        const firstCourse = rowData?.courses?.[0];
        return (
            firstCourse?.courseImage || firstCourse?.courseName ? (
                <div style={{ display: "flex", alignItems: "center", gap: "12px", minWidth: 0 }} title={firstCourse?.courseName}>
                    <div style={{ flexShrink: 0, width: '60px', height: '40px' }} >
                        {firstCourse?.courseImage && firstCourse?.courseImage !== 'null' ? (
                            <img
                                src={`${process.env.REACT_APP_BASE_URL}/${firstCourse?.courseImage}`}
                                alt=""
                                style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '4px' }}
                                onError={(e) => {
                                    e.target.src = "/img/placeholder-image.jpg"
                                }}
                            />
                        ) : (
                            <div style={{ width: '100%', height: '100%', background: '#e9ecef', borderRadius: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <i className="bi bi-journal-text text-secondary"></i>
                            </div>
                        )}
                    </div>
                    <div style={{ display: "flex", flexDirection: "column", minWidth: 0, flex: 1 }}>
                        <span className='show-more-text' style={{fontWeight: '600', fontSize: '0.9rem'}} > {firstCourse?.courseName || 'Unknown Course'} </span>
                        <span style={{ fontSize: '0.8rem', color: '#6b7280', marginTop: '2px' }}>
                            {courseCount} {courseCount === 1 ? 'Course' : 'Courses'}
                        </span>
                    </div>
                </div>
            ) : null
        );
    };

    const statusBodyTemplate = (rowData) => {
        return (
            <span className={`badge ${rowData.paymentStatus === 'success' ? 'bg-success' : 'bg-danger'}`}>
                {rowData.paymentStatus === 'success' ? 'Success' : 'Failed'}
            </span>
        );
    };

    const renderHeader = () => {
        return (
        <div className="flex justify-content-end">
            <IconField iconPosition="left">
                <InputIcon className="pi pi-search" />
                <InputText value={globalFilterValue} onChange={(e) => setGlobalFilterValue(e.target.value)} placeholder="Search" />
            </IconField>
        </div>
        );
    };

    return (
        <>
            <Toast ref={toast} />
            <ConfirmDialog />
            <Layout>
                <div class="content-wrapper">
                    <div class="container-xxl flex-grow-1 container-p-y">
                        <div class="d-flex justify-content-between align-items-center py-3">
                            <h4 class="fw-bold py-3 mb-2">
                                <span class="d-flex text-muted fw-light"> 
                                    <p class="breadcrumb-item pageHeader active me-2 mb-0" aria-current="page" onClick={() => navigate('/affiliates')}> Affiliates </p> / <b className='mx-2'> Orders </b>
                                </span>
                            </h4>
                        </div>
                        <div class="row">
                        <div class="col-md-12">
                            <div class="card mb-4">
                            <div class="card-body">
                                <DataTable globalFilter={globalFilterValue} header={renderHeader} paginator rows={50} rowsPerPageOptions={[50, 100, 150, 200]} showGridlines size="small" value={affiliateData} tableStyle={{ minWidth: '50rem' }} >
                                    <Column sortable header='S.NO' body={serialNoTemplate} />
                                    <Column sortable header='User Details' body={userDetailBodyTemplate} field='userName' />
                                    <Column sortable header='Course Name' body={imageBodyTemplate} field='courseName' />
                                    <Column sortable header='Order Number' field='orderNumber' />
                                    <Column sortable header='Total' field='grandTotal' />
                                    <Column sortable header='Commission' field='discountAmount' />
                                    <Column sortable header='Status' body={statusBodyTemplate} />
                                    <Column sortable header='Order Date' field='createdAt' body={(rowData) => {
                                        const date = new Date(rowData.createdAt);
                                        return date.toLocaleDateString("en-US", { year: "numeric", month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit", hour12: true, });
                                    }} />
                                </DataTable>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </Layout> 
        </>
    )
}

export default AffiliateOrders
